export interface ICustomerBillingSummary {
  amount?: number;
  startDate: string;
  endDate: string;
  totalCost: number;
  customerId: string;
}

export default class CustomerBillingSummary {
  private amount?: number;
  private startDate: string;
  private endDate: string;
  private totalCost: number;
  private customerId: string;

  constructor(dto: ICustomerBillingSummary) {
    Object.assign(this, dto);
  }

  get getAmount(): number {
    return this.amount;
  }

  set setAmount(amount: number) {
    this.amount = amount;
  }

  get getStartDate(): string {
    return this.startDate;
  }

  set setStartDate(startDate: string) {
    this.startDate = startDate;
  }

  get getEndDate(): string {
    return this.endDate;
  }

  set setEndDate(endDate: string) {
    this.endDate = endDate;
  }

  get getTotalCost(): number {
    return this.totalCost;
  }

  set setTotalCost(totalCost: number) {
    this.totalCost = totalCost;
  }

  get getCustomerId(): string {
    return this.customerId;
  }

  set setCustomerId(customerId: string) {
    this.customerId = customerId;
  }
}
